@if (['projection', 'default'].includes(layoutMode)) {
  <h3-image-renderer
    *h3Injector="contentInjector"
    class="layer overlay"
    [isInsideZoomPanel]="isInsideZoomPanel"
  ></h3-image-renderer>
}
@if (layoutMode === 'projection' && (isProjectionEnabled$ | async)) {
  <h3-projection-renderer
    *h3Injector="primaryOutputInjector"
    class="layer overlay"
    [size]="mainDisplaySize$ | async"
    [imageSize]="sensorRendererSize$ | async"
    [videoOutputName]="outputName"
    [isInsideZoomPanel]="isInsideZoomPanel"
    [lutData]="lutData$ | async"
  ></h3-projection-renderer>
}
@if (layoutMode === 'orthographic') {
  <h3-orthographic-renderer
    *h3Injector="primaryOutputInjector"
    class="layer overlay"
    [size]="mainDisplaySize$ | async"
    [videoOutputName]="outputName"
  ></h3-orthographic-renderer>
}

<div
  *ngFor="let layerStore of layerStores$ | async; let i = index"
  class="layer overlay"
  [class.active-layer]="i === state.activeLayerIndex"
>
  @switch (layerStore('type').$ | async) {
    @case ('vector_tagging') {
      <h3-vector-renderer
        *h3Injector="contentInjector"
        [isInsideZoomPanel]="isInsideZoomPanel"
        [size]="store('mainDisplaySize').$ | async"
        [attr.movement-disabled]="movementDisabled$ | async"
        [pixelSize]="pixelSize"
      ></h3-vector-renderer>
    }
    @case ('raster_coding') {
      <h3-raster-renderer
        *h3Injector="contentInjector"
        [isInsideZoomPanel]="isInsideZoomPanel"
        [size]="store('mainDisplaySize').$ | async"
      ></h3-raster-renderer>
    }
  }
</div>

<div
  class="overlays"
  *ngFor="let layerStore of layerStores$ | async; let i = index"
>
  <h3-vector-renderer
    *h3Injector="contentInjector"
    class="layer overlay"
    [isOverlay]="true"
    [isInsideZoomPanel]="isInsideZoomPanel"
    [pixelSize]="pixelSize"
  ></h3-vector-renderer>
  <!--
    Do not show a renderer if the output doesn't need it, to mitigate errors
    that can occur from requesting a WebGL context on a resource-constrained
    machine. (Production problem)
  -->
  <ng-container *ngIf="(layerStore('type').$ | async) === 'raster_coding'">
    <h3-raster-renderer
      *h3Injector="contentInjector"
      class="layer overlay"
      [isOverlay]="true"
      [isInsideZoomPanel]="isInsideZoomPanel"
    ></h3-raster-renderer>
    <h3-image-overlay-data
      *h3Injector="contentInjector"
      class="layer overlay"
    ></h3-image-overlay-data>
  </ng-container>
</div>
